export default "__VITE_ASSET__Dzm9vPQN__"